import { logger } from '@salescore/frontend-common'

import type { RSheetsCellInputRenderTypeArgument } from '../rSheetsCellInputRenderTypeArgument'

// 一応定義しているものの、booleanは編集モードになることがないため、使われない想定
// eslint-disable-next-line sonarjs/prefer-read-only-props
export function RSheetsCellBooleanInput({ boxStyle }: RSheetsCellInputRenderTypeArgument) {
  logger.debug(`booleanCellRender is called`)

  return (
    <div
      style={{
        ...boxStyle,
        // Spreadsheetと似たロジックで、中身の文字列が増えたら幅を広げて全部表示させる。
        // 他のセルの位置に影響を与えずこれを実現するため、position: absoluteにして実現している
        // width: Math.max(defaultWidth, calculateCharLength(value as string) * 10),
        padding: '6px 10px', // padingYはボーダーにかぶらなければなんでも良い
        marginTop: 1, // これがないと1pxずれるが、Cell側と比べてなぜ1px分の差があるのか不明
        marginLeft: 1,
        // boxShadow: '1px 4px 7px 2px rgb(60 64 67 / 15%)',
        pointerEvents: 'none', // チェックボックスの上にdivがあるとdivのクリックが反応するため、pointerEventsを無効化する
      }}
    ></div>
  )
}
